import { useEffect, type ReactNode } from 'react';
import { resolveAppThemeId, DEFAULT_APP_THEME_ID } from '@disenchantment/shared';
import { applyUserAppTheme } from './applyUserAppTheme';
import { useAuthStore } from '@/features/auth/auth.store';

interface AppThemeProviderProps {
  children: ReactNode;
}

/** Syncs the signed-in user's `appTheme` to CSS variables on the document root. */
export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const appThemeId = useAuthStore((s) => s.user?.appTheme);
  const appThemeCustomization = useAuthStore((s) => s.user?.appThemeCustomization);
  const loading = useAuthStore((s) => s.loading);

  useEffect(() => {
    const id = loading ? DEFAULT_APP_THEME_ID : resolveAppThemeId(appThemeId);
    const customization = loading ? null : appThemeCustomization;
    applyUserAppTheme(id, customization);
  }, [appThemeId, appThemeCustomization, loading]);

  return children;
}
